/**
 * @flow
 * @relayHash fbdff903594ae2a5510ab0184caaa2cf
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ProfessionUpdateInput = {|
  id: string,
  name: string,
|};
export type UpdateProfessionMutationVariables = {|
  data: ProfessionUpdateInput
|};
export type UpdateProfessionMutationResponse = {|
  +updateProfession: {|
    +id: string
  |}
|};
export type UpdateProfessionMutation = {|
  variables: UpdateProfessionMutationVariables,
  response: UpdateProfessionMutationResponse,
|};
*/


/*
mutation UpdateProfessionMutation(
  $data: ProfessionUpdateInput!
) {
  updateProfession(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "ProfessionUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateProfession",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "ProfessionModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateProfessionMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateProfessionMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateProfessionMutation",
    "id": null,
    "text": "mutation UpdateProfessionMutation(\n  $data: ProfessionUpdateInput!\n) {\n  updateProfession(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ad0f837b10595d0fda8ae1cd673dc070';
module.exports = node;
